import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { BASE_URL, USER_URL } from '../../constant/api';

function SubAdminCustomer() {
  const [customers, setCustomers] = useState([]);

  

  // Fetch customers on component mount
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await USER_URL.get(`/accounts/subadmin/customers/`);
        console.log("customers", response.data.data);
        setCustomers(response.data.data);
      } catch (error) {
        console.error('Error fetching customers:', error.message || error);
      }
    };
    fetchCustomers();
  }, []);

  return (
    <div className="container mx-auto">
      {/* Table Section */}
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-left">
          <thead>
            <tr>
              <th className="text-green-500 text-sm font-bold">Customer Name</th>
              <th className="p-2 text-green-500 text-sm font-bold">Location</th>
              <th className="p-2 text-green-500 text-sm font-bold">Join Date</th>
              <th className="p-2 text-green-500 text-sm font-bold">Status</th>
              <th className="p-2 text-green-500 text-sm font-bold">Sub Admin</th>
              <th className="p-2"></th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr key={customer.id}>
                <td>
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                    {customer.username}
                  </div>
                </td>
                
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {customer.location}
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
                    {customer.date_joined?.slice(0, 10)}
                    <FaRegCalendarAlt className="text-gray-400 text-base" />
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {customer.status}
                  </div>
                </td>
                <td className="p-2">
                  <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                    {customer.subadmin ? customer.subadmin : 'N/A'}
                  </div>
                </td>
                <td className="p-2">
                  <Link
                    to={`view/${customer.id}`}
                    className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100"
                  >
                    VIEW
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SubAdminCustomer;
